const currentYear = (new Date).getFullYear();

export function changeYear(val: any) {
    // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
    this.setState(({
                       year
                   }: any) => {
        if (year == null) {
            year = currentYear + val + (val < 0);
        } else if (year == currentYear && val == 1) {
            year = null;
        } else {
            year += val;
        }
        return {year};
    });
}
